export const PROTOCOL = '/ipfs/ping/1.0.0';
export const PING_LENGTH = 32;
export const PROTOCOL_VERSION = '1.0.0';
export const PROTOCOL_NAME = 'ping';
